export default __webpack_public_path__ + "static/Entenda0118-76e17bb9073149f45f1affa8e66b2bff.jpg";